import * as Sentry from '@sentry/react';
import { feedbackIntegration } from '@sentry/react';

type InitOptions = Parameters<typeof Sentry.init>[0];

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) return;

  const options: InitOptions = {
    dsn,
    environment: import.meta.env.MODE,
    enabled: Boolean(import.meta.env.PROD),
    integrations: (defaults) => [
      ...defaults,
      feedbackIntegration({
        enableScreenshot: true,
        showBranding: false,
        autoInject: false,
      }),
    ],
  };

  Sentry.init(options);
}

export { Sentry };
